import React from 'react';
import AssignIndex from './Assign/index'

const AssignUser = ({ organization, program, setTrigger, toggleParent }) => {
    return (
        <div>
            <div className="manager-program-modal__form-head">
                <h4 className="manager-program-modal__form-title">Available Users</h4>
                <p className="manager-program-modal__form-copy">
                    Search existing users and assign them into this program.
                </p>
            </div>
            <AssignIndex program={program} organization={organization} setTrigger={setTrigger} toggleParent={toggleParent} />
        </div>
    )
}
export default AssignUser;
